import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  status: void 0,
  Global: [],
  GlobalAll: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
